/**
 * One explanation of what an "API call" is, shared by every surface that
 * shows the monthly allowance (plan chooser, billing usage, public pricing).
 *
 * Only requests that a store's own systems make to the Products API are
 * metered (`meterCatalogApi` on /products and /cameras in app.ts); the MAP
 * pricing routes are not. Shopify, Lightspeed, BigCommerce and WooCommerce
 * syncs run inside Motzu and never touch that meter, and no plan restricts
 * them by call volume.
 */
export const API_CALLS_HINT =
  'Requests your own systems make to the Motzu Products API with an API key: catalog pulls, product detail and search. ' +
  'Dashboard use and integration syncs to Shopify, Lightspeed and the other connected platforms are not API calls, are not counted, and are not limited by this number.';

export const API_CALLS_EXAMPLES: string[] = [
  'A web developer pulling specs and images for 3,000 SKUs every night: about 90,000 calls a month.',
  'A custom storefront or in-store kiosk that looks up price and stock on each page view, 8,000 views a day: about 240,000 a month.',
  'A buying group or ERP polling the full catalog hourly, or several apps sharing one key: 500,000 and up.',
];
